import classNames from 'classnames/bind';
import React from 'react';

export class TabBar extends React.Component {
  state = {current: 0}

  onChange = (ev) => {
    const elem = ev.target;
    const id = elem.getAttribute('data-id');
    const param = elem.getAttribute('data-param');

    this.props.onChange(param);
    this.setState({current: parseInt(id)});
  }

  render() {
    const current = this.state.current;

    return (
      <div>
        <ul className="boxTab">
          {this.props.buttons.map(([value, key], index) => (
            <li key={index} className={classNames({'is-active': index == current})}>
              <a className="is-clickable" data-id={index} data-param={value} onClick={this.onChange}>{key}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
};
